import React, { useRef } from "react";
import { YHDrawer } from "@components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@components/YhFormBox/Types";
import { YhForm } from "@components/YhFormBox";
import { useMenuModel } from "../menuModel";
import { globalPrompt } from "@src/components/YhMessage";
import { resourceService } from "../../resource/ResourceService";
import useGlobalModel from "@src/model/globalModel";
import moment from "moment";
import { useLockFn } from "ahooks";


export function DetailDrawer() {
    const { user } = useGlobalModel();
    const {
        appCode,
        formValues,
        resourceModel,
        selectedData,
        drawerVisible,
        setDrawerVisible,
        loadTableData,
    } = useMenuModel();


    const formRef = useRef<IYhFormRef>();
    const formConfig: IYhForm = {
        formRef,
        labelCol: { span: 6 },
        disabled: resourceModel === 'look',
        initialValues: resourceModel === "edit" ? {
            ...selectedData,
            createTime: moment(selectedData?.createTime).format("YYYY-MM-DD HH:mm:ss"),
            status: selectedData?.status === 0 ? true : false
        } : {
                createUser: user.userName,
                createTime: moment().format("YYYY-MM-DD HH:mm:ss"),
                status: true,
            },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "资源编号",
                fieldName: "code",
                disable: resourceModel === "edit",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "资源名称",
                fieldName: "name",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                disable: true,
                fieldName: "createUser",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建时间",
                disable: true,
                fieldName: "createTime",
                span: 24,
            }, {
                type: FormItemTypeEnum.Switch,
                fieldLabel: "状态",
                fieldName: "status",
                span: 24,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "资源描述",
                fieldName: "note",
                span: 24,
            }
        ]
    };

    const onCancel = () => {
        setDrawerVisible(false);
    }
    const onOk = useLockFn(async () => {
        try {
            const formData = await formRef.current?.validateFields();
            if (formData) {
                const params = {
                    ...formData,
                    menuCode: formValues?.code,
                    appCode,
                    status: formData.status ? 0 : 1,
                }
                if (resourceModel !== "edit") {
                    const insertRet = await resourceService.insert(params);
                    if (insertRet.success) {
                        await globalPrompt("message", { type: "success", text: '新增成功!' });
                        onCancel()
                        loadTableData({ pageNum: 1 })
                    } else {
                        await globalPrompt("message", { type: "error", text: "新增失败!" + insertRet.retMsg });
                    }
                } else {
                    const updateRet = await resourceService.update(params);
                    if (updateRet.success) {
                        await globalPrompt("message", { type: "success", text: '修改成功!' });
                        onCancel()
                        loadTableData({ pageNum: 1 })
                    } else {
                        await globalPrompt("message", { type: "error", text: "修改失败!" + updateRet.retMsg });
                    }
                }
            }
        } catch (e) {
            console.log("失败!");
        }
    })


    return (
        <YHDrawer
            {...{
                title: "资源详情",
                visible: drawerVisible,
                onCancel,
                showFooter: true,
                onOk,
            }}
        >
            {/*<DetailForm/>*/}
            <YhForm  {...formConfig} />
        </YHDrawer>
    )
}
